import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import {
  GetUpdateHistoriesResponse,
  getUpdateHistories,
} from '@apis/esimBulk/update';

export const useUpdateHistories = ({ page }: { page: number }) => {
  const queryOptions: UseQueryOptions<
    PageResponse<GetUpdateHistoriesResponse>,
    Error
  > = {
    queryKey: ['updateHistories', page],
    queryFn: () => {
      return getUpdateHistories({
        pageNo: page,
        pageSize: 50,
      });
    },
  };
  return useQuery(queryOptions);
};
